export default "__VITE_ASSET__610xzwBQ__"